import { ModalWithForm } from '@/components/ats';
import { PauseForCustomField } from './PauseForCustomField';
import dayjs from 'dayjs';
import { useShowToast } from '@/hooks';
import { usePauseApplicationMutation } from '@/store/query/ats-applications';
import * as Yup from 'yup';

export const PauseApplication = ({
  modalActions,
  modalClose = () => {},
  refetchApplication = () => {},
  applicationData = {},
}) => {
  const [pauseApp, { isLoading }] = usePauseApplicationMutation();
  const toast = useShowToast();

  const pauseFormFields = [
    {
      type: 'custom',
      Field: PauseForCustomField,
    },
    {
      name: 'note',
      type: 'textArea',
      label: 'Pause reason',
      placeholder: 'Enter your pause reason',
      isRequired: true,
      maxLength: 250,
      validation: Yup.string().required('Pause reason is required').trim(),
    },
  ];
  const pauseDurations = {
    week: { amount: 7, unit: 'day' },
    month: { amount: 1, unit: 'month' },
    '3month': { amount: 3, unit: 'month' },
  };

  const handleSubmit = async (values) => {
    const { customDate, note = '', pauseUntill = 'week' } = values;
    const payload = { pause_reason: note };
    const currDate = dayjs();
    const duration = pauseDurations?.[pauseUntill];
    if (pauseUntill === 'custom') {
      payload.pause_end_at = dayjs(customDate)?.toISOString();
    } else {
      payload.pause_end_at = currDate
        .add(duration.amount, duration.unit)
        ?.toISOString();
    }
    const result = await pauseApp({
      applicationId: applicationData?.id,
      payload,
    });
    if (result?.error?.length) {
      toast({ title: 'Pausing the candidate failed', status: 'error' });
    } else {
      toast({ title: 'Candidate paused successfully' });
      modalActions?.onClose();
      refetchApplication();
    }
  };

  return (
    <ModalWithForm
      isOpen={modalActions.isOpen}
      onClose={modalClose}
      headerText={'Pause candidate'}
      subHeaderText={'Mark a candidate as paused for the specified duration'}
      primaryCtaText="Pause"
      formConfig={pauseFormFields}
      initialValues={{ pauseUntill: 'week', note: '' }}
      handleSubmit={handleSubmit}
      isCtaLoading={isLoading}
    />
  );
};
